(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["editorial-cart-feedback"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('editorial-cart-feedback')) {
    customElements.define('editorial-cart-feedback', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.querySelector('[data-dismiss]').addEventListener('click', () => this.hide(true), options);
        this.querySelector('[data-view-cart]').addEventListener('click', event => {
          const cart = document.querySelector('cart-drawer');
          if (!cart) return;
          event.preventDefault();
          cart.open(document.querySelector('#cart-icon-bubble'));
        }, options);
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !this.hidden) this.hide(true);
        }, options);
      }
      show(item, preview = null) {
        this.returnFocus = document.activeElement;
        this.hidden = false;
        this.querySelector('[data-product-name]').textContent = item.product_title || item.title || '';
        const photo = this.querySelector('[data-product-image]');
        photo.hidden = true;
        photo.removeAttribute('src');
        const source = item.featured_image?.url || item.image;
        if (source) {
          try {
            const url = new URL(source, location.origin);
            if (url.protocol === 'https:') {
              photo.onerror = () => { photo.hidden = true; };
              photo.src = url.href;
              photo.hidden = false;
            }
          } catch {}
        }
        const shipping = this.querySelector('[data-shipping-feedback]');
        shipping.replaceChildren();
        const progress = document.querySelector('cart-drawer .editorial-shipping-progress');
        shipping.hidden = !progress;
        if (progress) {
          const copy = progress.cloneNode(true);
          copy.querySelector('a')?.remove();
          const meter = copy.querySelector('progress');
          if (preview) {
            meter.max = preview.threshold;
            meter.value = preview.total;
          }
          const remaining = Math.max(0, meter.max - meter.value);
          const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(remaining / 100);
          copy.querySelector('p').textContent = remaining ? this.dataset.remaining.replace('__AMOUNT__', amount) : this.dataset.reached;
          shipping.append(copy);
        }
      }
      hide(restoreFocus = false) {
        const containedFocus = this.contains(document.activeElement);
        this.hidden = true;
        if (restoreFocus && containedFocus) this.returnFocus?.focus({ preventScroll: true });
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["editorial-gallery-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('editorial-gallery-controls')) {
    customElements.define('editorial-gallery-controls', class extends HTMLElement {
      connectedCallback() {
        this.strip = this.parentElement.querySelector('.product__images-wrapper');
        if (!this.strip) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.update = () => {
          const media = [...this.strip.querySelectorAll('.product__media__wrapper')];
          const top = this.strip.getBoundingClientRect().top;
          this.index = media.reduce((closest, item, index) => Math.abs(item.getBoundingClientRect().top - top) < Math.abs(media[closest].getBoundingClientRect().top - top) ? index : closest, 0);
          this.querySelectorAll('[data-index]').forEach(button => button.setAttribute('aria-current', String(Number(button.dataset.index) === this.index)));
        };
        this.strip.addEventListener('scroll', this.update, { ...options, passive: true });
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-index]');
          if (!button) return;
          const item = this.strip.querySelectorAll('.product__media__wrapper')[Number(button.dataset.index)];
          if (!item) return;
          const top = this.strip.scrollTop + item.getBoundingClientRect().top - this.strip.getBoundingClientRect().top;
          this.strip.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, options);
        this.resize = new ResizeObserver(this.update);
        this.resize.observe(this.strip);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["editorial-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    const setup = () => {
      if (!document.body.classList.contains('template-index')) return;
      window.editorialHomeCleanup?.();
      const panels = Array.from(document.querySelectorAll('#MainContent > .shopify-section'));
      const logo = document.querySelector('.header__heading-link');
      if (!panels.length || !logo) return;
      const abort = new AbortController();
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let frame, headerHeight;
      const introStart = performance.now();
      const introEnabled = window.scrollY < 2;
      const measure = () => {
        logo.style.transform = '';
        headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 64;
        panels.forEach((panel, index) => {
          panel.classList.add('editorial-motion-panel');
          panel.style.setProperty('--editorial-panel-index', index + 1);
          const bottomInset = matchMedia('(max-width: 749px)').matches ? 0 : 24;
          panel.style.setProperty('--editorial-panel-top', `${Math.min(headerHeight, innerHeight - panel.offsetHeight - bottomInset)}px`);
          let position = panel.querySelector('.editorial-slide-position');
          if (!position) {
            position = document.createElement('span');
            position.className = 'editorial-slide-position';
            position.setAttribute('aria-hidden', 'true');
            panel.append(position);
          }
          position.textContent = `${index + 1} / ${panels.length}`;
        });
        draw();
      };
      const draw = () => {
        frame = null;
        const intro = introEnabled && !reduced.matches ? Math.max(0, 1 - (performance.now() - introStart) / 720) ** 3 : 0;
        logo.style.transform = `translate3d(0, ${-8 * intro}px, 0) scale(${1 + .08 * intro})`;
        if (intro > 0) frame = requestAnimationFrame(draw);
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(draw); };
      document.body.classList.add('editorial-home-ready');
      const resize = new ResizeObserver(measure);
      panels.forEach(panel => resize.observe(panel));
      window.addEventListener('scroll', schedule, { passive: true, signal: abort.signal });
      window.addEventListener('resize', measure, { signal: abort.signal });
      reduced.addEventListener('change', measure, { signal: abort.signal });
      window.editorialHomeCleanup = () => { abort.abort(); resize.disconnect(); cancelAnimationFrame(frame); logo.style.transform = ''; };
      measure();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
    else setup();
    document.addEventListener('shopify:section:load', setup);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["editorial-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('editorial-product-details')) {
    customElements.define('editorial-product-details', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const dialog = this.querySelector('dialog');
        const summary = this.querySelector('summary');
        const details = this.querySelector('details');
        const copy = this.querySelector('.editorial-details-copy');
        if (!dialog.showModal) return;
        document.addEventListener('pointerdown', () => summary.setAttribute('data-pointer-focus', ''), options);
        document.addEventListener('keydown', event => {
          if (!['Shift', 'Control', 'Alt', 'Meta'].includes(event.key)) summary.removeAttribute('data-pointer-focus');
        }, options);
        summary.setAttribute('aria-haspopup', 'dialog');
        summary.addEventListener('click', event => {
          event.preventDefault();
          dialog.removeAttribute('data-closing');
          dialog.append(copy);
          dialog.showModal();
        }, options);
        const close = () => {
          if (matchMedia('(prefers-reduced-motion: reduce)').matches) dialog.close();
          else dialog.setAttribute('data-closing', '');
        };
        dialog.addEventListener('animationend', event => {
          if (event.target === dialog && dialog.hasAttribute('data-closing')) dialog.close();
        }, options);
        dialog.addEventListener('cancel', event => { event.preventDefault(); close(); }, options);
        dialog.querySelector('button').addEventListener('click', close, options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
        }, options);
        dialog.addEventListener('close', () => {
          dialog.removeAttribute('data-closing');
          details.append(copy);
          summary.focus({ preventScroll: true });
        }, options);
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["editorial-product-sheet"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('editorial-product-sheet')) {
    customElements.define('editorial-product-sheet', class extends HTMLElement {
      connectedCallback() {
        this.product = this.closest('.product');
        if (!this.product?.querySelector('.product__images')) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const button = this.querySelector('button');
        const panel = this.closest('.product__info-wrapper');
        this.product.classList.add('editorial-sheet-ready');
        const headerHeight = () => parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 64;
        const strip = this.product.querySelector('.product__images-wrapper');
        const handOff = (event, delta) => {
          if (!matchMedia('(max-width: 749px)').matches || !event.cancelable || !delta) return;
          const atEnd = strip.scrollTop + strip.clientHeight >= strip.scrollHeight - 2;
          const pageStart = window.scrollY + this.product.getBoundingClientRect().top - headerHeight();
          const pageMoved = window.scrollY > pageStart + 2;
          if ((delta > 0 && atEnd) || (delta < 0 && pageMoved)) {
            event.preventDefault();
            window.scrollBy({ top: delta < 0 ? Math.max(delta, pageStart - window.scrollY) : delta, behavior: 'instant' });
          }
        };
        strip.addEventListener('wheel', event => {
          if (event.ctrlKey || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
          const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? strip.clientHeight : 1;
          handOff(event, event.deltaY * unit);
        }, { ...options, passive: false });
        strip.addEventListener('touchstart', event => {
          this.touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { ...options, passive: true });
        strip.addEventListener('touchmove', event => {
          if (!this.touch || event.touches.length !== 1) return;
          const touch = event.touches[0];
          const delta = this.touch.y - touch.clientY;
          const horizontal = Math.abs(this.touch.x - touch.clientX);
          this.touch = { x: touch.clientX, y: touch.clientY };
          if (Math.abs(delta) >= horizontal) handOff(event, delta);
        }, { ...options, passive: false });
        strip.addEventListener('touchend', () => { this.touch = null; }, options);
        strip.addEventListener('touchcancel', () => { this.touch = null; }, options);
        const setExpanded = expanded => {
          const target = expanded ? panel : this.product;
          window.scrollTo({ top: window.scrollY + target.getBoundingClientRect().top - headerHeight(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        const updateState = () => {
          const expanded = panel.getBoundingClientRect().top <= headerHeight() + 24;
          button.setAttribute('aria-expanded', String(expanded));
          button.setAttribute('aria-label', expanded ? button.dataset.collapse : button.dataset.expand);
        };
        window.addEventListener('scroll', updateState, { ...options, passive: true });
        button.addEventListener('click', () => {
          if (this.dragged) { this.dragged = false; return; }
          setExpanded(button.getAttribute('aria-expanded') !== 'true');
        }, options);
        button.addEventListener('pointerdown', event => { this.startY = event.clientY; this.dragged = false; button.setPointerCapture(event.pointerId); }, options);
        button.addEventListener('pointerup', event => {
          const delta = event.clientY - this.startY;
          if (Math.abs(delta) > 30) { this.dragged = true; setExpanded(delta < 0); }
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') setExpanded(false);
        }, options);
        this.resize = new ResizeObserver(() => {
          if (!matchMedia('(max-width: 749px)').matches) return;
          updateState();
        });
        this.resize.observe(this.closest('.product__info-wrapper'));
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["editorial-wishlist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('editorial-wishlist')) {
    customElements.define('editorial-wishlist', class extends HTMLElement {
      connectedCallback() {
        this.key = 'valfre-wishlist-v1';
        this.dialog = this.querySelector('dialog');
        if (!this.dialog.showModal) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.sync();
        this.observer = new MutationObserver(records => {
          if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 &&
            (node.matches('[data-wish-toggle], [data-wish-open]') || node.querySelector('[data-wish-toggle], [data-wish-open]'))))) this.sync();
        });
        this.observer.observe(document.body, { childList: true, subtree: true });
        document.addEventListener('click', event => {
          const toggle = event.target.closest('[data-wish-toggle]');
          const open = event.target.closest('[data-wish-open]');
          if (toggle) {
            event.preventDefault();
            this.lastToggle = toggle;
            const items = this.read();
            const existing = items.some(item => item.handle === toggle.dataset.handle);
            const next = existing ? items.filter(item => item.handle !== toggle.dataset.handle) : [...items, {
              handle: toggle.dataset.handle, title: toggle.dataset.title,
              url: toggle.dataset.url, image: toggle.dataset.image
            }];
            if (this.save(next)) {
              this.sync();
              this.notify(existing ? this.dataset.removed : this.dataset.saved);
            }
          }
          if (open) {
            event.preventDefault();
            this.hideFeedback();
            this.returnFocus = open.closest('[data-wish-feedback]') ? this.lastToggle : open;
            const drawer = open.closest('header-drawer');
            if (drawer) {
              this.returnFocus = drawer.querySelector('summary');
              drawer.closeMenuDrawer(event, this.returnFocus);
            }
            this.render();
            this.dialog.showModal();
            document.body.classList.add('editorial-wishlist-open');
          }
        }, options);
        this.querySelector('[data-wish-dismiss]').addEventListener('click', () => this.hideFeedback(), options);
        this.querySelector('[data-wish-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          document.body.classList.remove('editorial-wishlist-open');
          this.returnFocus?.focus({ preventScroll: true });
        }, options);
        window.addEventListener('storage', event => {
          if (event.key !== this.key && event.key !== null) return;
          this.sync();
          if (this.dialog.open) this.render();
        }, options);
      }
      read() {
        try {
          const items = JSON.parse(localStorage.getItem(this.key) || '[]');
          return Array.isArray(items) ? items.filter(item => item && typeof item.handle === 'string' && typeof item.title === 'string' && typeof item.url === 'string' && item.url.startsWith('/') && !item.url.startsWith('//')) : [];
        } catch { return []; }
      }
      notify(message) {
        this.querySelector('[data-wish-status]').textContent = message;
        this.querySelector('[data-wish-message]').textContent = message;
        this.querySelector('[data-wish-feedback]').hidden = false;
      }
      hideFeedback() {
        this.querySelector('[data-wish-feedback]').hidden = true;
      }
      save(items) {
        try {
          localStorage.setItem(this.key, JSON.stringify(items));
          this.querySelector('[data-wish-error]').hidden = true;
          return true;
        } catch {
          this.notify(this.dataset.error);
          this.querySelector('[data-wish-error]').hidden = false;
          return false;
        }
      }
      sync() {
        const saved = new Set(this.read().map(item => item.handle));
        document.querySelectorAll('[data-wish-toggle]').forEach(button => {
          const active = saved.has(button.dataset.handle);
          button.hidden = false;
          button.setAttribute('aria-pressed', String(active));
          button.setAttribute('aria-label', active ? this.dataset.remove : this.dataset.save);
          button.title = active ? this.dataset.remove : this.dataset.save;
        });
        document.querySelectorAll('[data-wish-open]').forEach(button => { button.hidden = false; });
        document.querySelectorAll('.editorial-wishlist-desktop[data-wish-open]').forEach(button => {
          let badge = button.querySelector('[data-wish-header-count]');
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'editorial-wishlist-count';
            badge.setAttribute('data-wish-header-count', '');
            badge.setAttribute('aria-hidden', 'true');
            button.append(badge);
          }
          badge.textContent = String(saved.size);
          badge.hidden = saved.size === 0;
          button.setAttribute('aria-label', `${button.title} (${saved.size})`);
        });
      }
      render() {
        const items = this.read();
        this.querySelector('[data-wish-count]').textContent = `(${items.length})`;
        this.querySelector('[data-wish-empty]').hidden = items.length > 0;
        const list = this.querySelector('[data-wish-list]');
        list.replaceChildren();
        items.forEach(item => {
          const row = document.createElement('li');
          const link = document.createElement('a');
          link.href = item.url;
          link.title = this.dataset.view;
          let imageUrl;
          try { imageUrl = typeof item.image === 'string' && item.image ? new URL(item.image, location.origin) : null; } catch { imageUrl = null; }
          if (imageUrl && imageUrl.protocol === 'https:' && (imageUrl.hostname === 'cdn.shopify.com' || (imageUrl.origin === location.origin && imageUrl.pathname.startsWith('/cdn/shop/')))) {
            const image = document.createElement('img');
            image.src = imageUrl.href;
            image.alt = '';
            image.width = 100;
            image.height = 125;
            image.loading = 'lazy';
            link.append(image);
          }
          const title = document.createElement('span');
          title.textContent = item.title;
          link.append(title);
          const remove = document.createElement('button');
          remove.className = 'editorial-wish-remove';
          remove.type = 'button';
          remove.textContent = '\u00d7';
          remove.setAttribute('aria-label', `${this.dataset.remove}: ${item.title}`);
          remove.title = this.dataset.remove;
          remove.addEventListener('click', () => {
            if (!this.save(this.read().filter(saved => saved.handle !== item.handle))) return;
            this.sync();
            this.render();
            this.querySelector('[data-wish-close]').focus();
          });
          row.append(link, remove);
          list.append(row);
          this.purchaseControl(item, row);
        });
      }
      async purchaseControl(item, row) {
        const fallback = document.createElement('a');
        fallback.className = 'editorial-wish-action';
        fallback.href = item.url;
        fallback.textContent = this.dataset.view;
        row.append(fallback);
        try {
          const response = await fetch(`${this.dataset.root}products/${encodeURIComponent(item.handle)}.js`, { signal: this.abort.signal });
          if (!response.ok) return;
          const product = await response.json();
          if (!row.isConnected || !Array.isArray(product.variants)) return;
          if (product.variants.length > 1 && product.available) {
            fallback.textContent = this.dataset.choose;
            return;
          }
          const variant = product.variants[0];
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'editorial-wish-action';
          button.disabled = !product.available || !variant?.available || !!product.requires_selling_plan;
          if (product.requires_selling_plan) return;
          button.textContent = button.disabled ? this.dataset.soldOut : this.dataset.add;
          button.setAttribute('aria-label', `${button.textContent}: ${item.title}`);
          const error = document.createElement('p');
          error.className = 'editorial-wish-cart-error';
          error.setAttribute('role', 'alert');
          error.hidden = true;
          button.addEventListener('click', () => this.addToCart(variant.id, button, error));
          fallback.replaceWith(button);
          row.append(error);
        } catch { /* Keep the product link available if product lookup fails. */ }
      }
      async addToCart(variantId, button, error) {
        if (this.adding) return;
        this.adding = true;
        button.disabled = true;
        button.textContent = this.dataset.adding;
        error.hidden = true;
        let added = false;
        try {
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const sections = cart?.getSectionsToRender().map(section => section.id) || [];
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1, sections, sections_url: location.pathname })
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || this.dataset.cartError);
          added = true;
          this.dialog.close();
          if (!cart || sections.some(id => !result.sections?.[id])) {
            location.assign(this.dataset.cartUrl);
            return;
          }
          cart.setActiveElement(this.returnFocus);
          cart.classList.remove('is-empty');
          cart.renderContents(result);
          if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist', productVariantId: variantId, cartData: result });
        } catch (failure) {
          if (added) { location.assign(this.dataset.cartUrl); return; }
          error.textContent = failure.message === 'Failed to fetch' ? this.dataset.cartError : failure.message;
          error.hidden = false;
        } finally {
          this.adding = false;
          button.disabled = false;
          button.textContent = this.dataset.add;
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        document.body.classList.remove('editorial-wishlist-open');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
